let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("era9z")).then(() => parcelRequire('l5flR'));